export default __webpack_public_path__ + "static/media/BUE-ProductionUnit.2b375ae5.png";